import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/$')({
    beforeLoad: () => {
        // Redirect any unmatched route to the 404 page
        throw redirect({ to: '/404' })
    },
})
